import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {ExternalLinkPoint} from 'main/factories/usecases/endpoints';
import {GetWhoIndicatesLink} from 'domain/usecases/private/home/who-indicates';
import {RemoteWhoIndicatesLink} from 'data/usecases/private/home/who-indicates';

export const makeGetWhoIndicatesLink = (): GetWhoIndicatesLink =>
	new RemoteWhoIndicatesLink(
		makeBFFApiUrl(ExternalLinkPoint.whoIndicates),
		makeAuthorizeHttpClientDecorator(),
	);
